import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
  Collapse,
  Button,
  Input
} from "reactstrap";
import IntlMessages from "Util/IntlMessages";
import { LAYOUT_MAX_WIDTH_400 } from "Constants/reactifyInlineStyles";
import { useAsyncResource } from "../../../../../hooks/useAsyncResource";
import { suiteApi } from "../../../../../api/suiteAdapters";
import {
  AsyncStateBoundary,
  SuitePageShell
} from "../../_suite/primitives";

export default function MacrosLibraryPage() {
  const [openId, setOpenId] = useState<string | null>(null);
  const [q, setQ] = useState("");
  const { data, loading, error } = useAsyncResource(
    () => suiteApi.ticketing.listMacros(),
    []
  );

  const rows = useMemo(() => {
    const list = data || [];
    const term = q.trim().toLowerCase();
    if (!term) return list;
    return list.filter(
      m =>
        String(m.title).toLowerCase().includes(term) ||
        String(m.shortcut).toLowerCase().includes(term)
    );
  }, [data, q]);

  return (
    <SuitePageShell
      heading={<IntlMessages id="suite.ticketing.macros" />}
      afterBreadcrumb={
        <p className="text-muted small mb-0">
          Canned responses with shortcuts — preview before inserting into a
          reply composer.
        </p>
      }
    >
      <Input
        type="search"
        className="mb-4"
        style={LAYOUT_MAX_WIDTH_400}
        placeholder="Search macros…"
        value={q}
        onChange={e => setQ(e.target.value)}
      />

      <AsyncStateBoundary
        loading={loading}
        error={error}
        empty={!loading && rows.length === 0}
      >
        {rows.map(m => (
          <Card key={m.id} className="mb-3 border-0 shadow-sm">
            <CardBody>
              <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
                <div>
                  <Badge color="dark" className="me-2 font-monospace">
                    {m.shortcut}
                  </Badge>
                  <CardTitle tag="h5" className="d-inline">
                    {m.title}
                  </CardTitle>
                  <p className="text-muted small mb-0 mt-1">
                    Updated {m.updatedAt}
                  </p>
                </div>
                <Button
                  color="link"
                  size="sm"
                  className="p-0"
                  onClick={() => setOpenId(openId === m.id ? null : m.id)}
                >
                  {openId === m.id ? "Hide preview" : "Show preview"}
                </Button>
              </div>
              <Collapse isOpen={openId === m.id}>
                <pre className="bg-light rounded p-3 small mt-3 mb-0 text-wrap">
                  {m.body ||
                    "Macro body would load from your knowledge base API."}
                </pre>
                <Button color="primary" size="sm" className="mt-2" disabled>
                  Insert into reply (wire composer)
                </Button>
              </Collapse>
            </CardBody>
          </Card>
        ))}
      </AsyncStateBoundary>
    </SuitePageShell>
  );
}
